import { Component, computed, inject, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderService } from './loader.service';


@Component({
  selector: 'app-loader',
  imports: [MatProgressSpinnerModule, TranslateModule],
  providers: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  public loaderService = inject(LoaderService);

  // Stato globale: almeno una sessione è attiva
  isLoading = this.loaderService.isLoading;

  // Messaggio della sessione più recente
  message = this.loaderService.currentMessage;

  // Progresso della sessione più recente
  progress = this.loaderService.currentProgress;

  constructor() {
  }
}
